import React, { useMemo, useState } from "react";
import useAuth from "../../../../Hooks/useAuth";
import usePermission from "../../../../Hooks/usePermission";
import { useFirmUsersData } from "../../../../Hooks/useFirmUsersData";
import { useGetRoleTemplatesQuery } from "../../../../store";
import { EmptyState } from "../../../shared";
import {
  ALL_TEMPLATES,
  countByTemplate,
  templateFilterFor,
  userTemplateId,
} from "../../../../utils/templateGrouping";
import UsersTab from "./UsersTab";
import RoleTemplatesTab from "./RoleTemplatesTab";

/**
 * KULLANICILAR + KULLANICI ŞABLONLARI tek sekmede (#298, merkez paneli).
 * Solda şablon sütunu (kişi sayılarıyla), sağda kullanıcı listesi; şablona
 * tıklamak listeyi süzer. Sekme iki izinden biriyle açılır — sütun
 * `firms.roleTemplatesRead`, liste `firms.users` ister.
 */
export default function UsersWithTemplatesTab({ firm, readOnly }) {
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  const canUsers = hasPermission("firms.users");
  const canTemplates = hasPermission("firms.roleTemplatesRead");
  const [selectedId, setSelectedId] = useState(ALL_TEMPLATES);

  // Liste tek yerden çekilir: hem sayımlar hem UsersTab bunu kullanır.
  const usersData = useFirmUsersData(
    canUsers ? { id: firm?._id, token: auth.accessToken } : { id: null, token: null }
  );
  // RoleTemplatesTab ile aynı argüman — RTK Query tek istek atar.
  const { data: templatesRes } = useGetRoleTemplatesQuery(
    { token: auth.accessToken, id: firm?._id },
    { skip: !firm?._id || !canTemplates }
  );
  const templates = useMemo(() => templatesRes?.data?.templates || [], [templatesRes]);

  const stats = useMemo(
    () => countByTemplate(usersData.users, templates, userTemplateId),
    [usersData.users, templates]
  );
  const extraFilter = useMemo(
    () => (selectedId === ALL_TEMPLATES ? undefined : templateFilterFor(selectedId, templates, userTemplateId)),
    [selectedId, templates]
  );

  return (
    <div className="flex flex-col md:flex-row h-full min-h-0">
      {canTemplates && (
        <RoleTemplatesTab
          firm={firm}
          readOnly={readOnly}
          selectedId={selectedId}
          onSelect={setSelectedId}
          stats={stats}
        />
      )}
      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        {canUsers ? (
          <UsersTab
            firm={firm}
            readOnly={readOnly}
            externalData={usersData}
            extraFilter={extraFilter}
            hideRoleFilter={canTemplates}
          />
        ) : (
          <EmptyState
            message="Kullanıcı listesini görme yetkiniz yok"
            suggestion="Şablonları soldan yönetebilirsiniz."
          />
        )}
      </div>
    </div>
  );
}
